// extracted by mini-css-extract-plugin
export default {"mainFieldContainer":"FileSearchFilterCriteriaArea_mainFieldContainer__zQKH8","adminIconArea":"FileSearchFilterCriteriaArea_adminIconArea__nNYng"};